"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = _interopRequireDefault(require("immutable"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _InitialFilterParams = _interopRequireDefault(require("../constants/InitialFilterParams"));

var _sidebarUtils = require("../utils/sidebarUtils");

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var _default = _react.default.createClass({
  displayName: "InlineCurrentFilters",
  mixins: [_ComponentWithPartials.default, _reactAddonsPureRenderMixin.default],
  propTypes: {
    goodFilters: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
    onGoodFilterChange: _react.PropTypes.func.isRequired
  },
  handleMultiselectFilterRemoval: function handleMultiselectFilterRemoval(filterType, selectedFilters, filterToRemove) {
    return this.props.onGoodFilterChange((0, _utils.getMultiselectFilterObjAfterRemove)(filterType, selectedFilters, filterToRemove));
  },
  renderFilter: function renderFilter(currentFilter, filterTextLookup, removeFilter) {
    return _react.default.createElement(_UITag.default, {
      className: "integrate-current-filter-tag",
      closeable: true,
      inline: true,
      key: currentFilter,
      onCloseClick: removeFilter
    }, filterTextLookup(currentFilter));
  },
  renderCategoryFilter: function renderCategoryFilter(categoryFilter) {
    return this.renderSingleSelectFilter(categoryFilter, _GoodFiltersAndPage.default.SUB_TYPE, _langUtils.getCategoryOptionText);
  },
  renderMultiselectFilters: function renderMultiselectFilters(filterType, filters) {
    var _this = this;

    return filters.map(function (filter) {
      return _this.renderFilter(filter, _this.partial(_langUtils.getMultiselectFilterOptionOrTitleText, filterType), _this.partial(_this.handleMultiselectFilterRemoval, filterType, filters, filter));
    });
  },
  renderSingleSelectFilter: function renderSingleSelectFilter(currentFilter, filterType, filterTextLookup) {
    var onGoodFilterChange = this.props.onGoodFilterChange;
    var defaultValue = filterType === _GoodFiltersAndPage.default.SUB_TYPE ? (0, _sidebarUtils.getParentCategory)(currentFilter) : _InitialFilterParams.default.get(filterType);

    if (currentFilter !== defaultValue) {
      return this.renderFilter(currentFilter, filterTextLookup, this.partial(onGoodFilterChange, (0, _defineProperty2.default)({}, filterType, defaultValue)));
    }

    return null;
  },
  renderPageLayoutFilter: function renderPageLayoutFilter(pageLayoutFilter) {
    return this.renderSingleSelectFilter(pageLayoutFilter, _GoodFiltersAndPage.default.PAGE_LAYOUT, _langUtils.getPageLayoutOptionText);
  },
  renderTemplatePurposeFilter: function renderTemplatePurposeFilter(templatePurposeFilter) {
    return this.renderSingleSelectFilter(templatePurposeFilter, _GoodFiltersAndPage.default.TEMPLATE_PURPOSE, _langUtils.getTemplatePurposeOptionText);
  },
  renderIndustryFilter: function renderIndustryFilter(industryFilter) {
    return this.renderSingleSelectFilter(industryFilter, _GoodFiltersAndPage.default.INDUSTRY, _langUtils.getIndustryOptionText);
  },
  renderProviderFilter: function renderProviderFilter(providerFilter) {
    return this.renderSingleSelectFilter(providerFilter, _GoodFiltersAndPage.default.PROVIDER, _langUtils.getProviderOptionText);
  },
  renderSidebarFilterTags: function renderSidebarFilterTags(goodFilters, onGoodFilterChange) {
    var categoryFilter = goodFilters.get(_GoodFiltersAndPage.default.SUB_TYPE);
    var childTypeFilters = goodFilters.get(_GoodFiltersAndPage.default.CHILD_TYPES);
    var codingTypeFilters = goodFilters.get(_GoodFiltersAndPage.default.CODING_TYPE);
    var priceFilters = goodFilters.get(_GoodFiltersAndPage.default.PRICE);
    var industryFilter = goodFilters.get(_GoodFiltersAndPage.default.INDUSTRY);
    var featureFilters = goodFilters.get(_GoodFiltersAndPage.default.FEATURES);
    var pageLayoutFilter = goodFilters.get(_GoodFiltersAndPage.default.PAGE_LAYOUT);
    var templatePurposeFilter = goodFilters.get(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE);
    var customModulePurposeFilter = goodFilters.get(_GoodFiltersAndPage.default.MODULE_PURPOSE);
    var customModuleCompatibilityFilter = goodFilters.get(_GoodFiltersAndPage.default.MODULE_COMPATIBILITY);
    var providerFilter = goodFilters.get(_GoodFiltersAndPage.default.PROVIDER);
    var isCategory = (0, _sidebarUtils.isMainCategory)(categoryFilter);
    var mainCategory = isCategory ? categoryFilter : (0, _sidebarUtils.getParentCategory)(categoryFilter);
    return _react.default.createElement("span", null, !isCategory && _I18n.default.text('sortingBar.filteredBy'), ' ', _react.default.createElement(_UIList.default, {
      inline: true
    }, !isCategory && this.renderCategoryFilter(categoryFilter), this.renderMultiselectFilters(_GoodFiltersAndPage.default.PRICE, priceFilters), this.renderMultiselectFilters(_GoodFiltersAndPage.default.CODING_TYPE, codingTypeFilters), this.renderMultiselectFilters(_GoodFiltersAndPage.default.CHILD_TYPES, childTypeFilters), this.renderMultiselectFilters(_GoodFiltersAndPage.default.FEATURES, featureFilters), this.renderPageLayoutFilter(pageLayoutFilter), this.renderTemplatePurposeFilter(templatePurposeFilter), this.renderIndustryFilter(industryFilter), this.renderMultiselectFilters(_GoodFiltersAndPage.default.MODULE_PURPOSE, customModulePurposeFilter), this.renderMultiselectFilters(_GoodFiltersAndPage.default.MODULE_COMPATIBILITY, customModuleCompatibilityFilter), this.renderProviderFilter(providerFilter)), _react.default.createElement(_UIButton.default, {
      className: "clear-filters-btn",
      size: "small",
      use: "link",
      onClick: this.partial(onGoodFilterChange, (0, _utils.getClearedSidebarFilters)(mainCategory))
    }, _I18n.default.text('sidebar.currentFiltersCard.clearAll')));
  },
  renderMatchingSearch: function renderMatchingSearch(searchTerm) {
    return _react.default.createElement("span", null, _I18n.default.text('sortingBar.matching'), " ", _react.default.createElement("strong", null, "'", searchTerm, "'"), ' ');
  },
  render: function render() {
    var _this$props = this.props,
        goodFilters = _this$props.goodFilters,
        onGoodFilterChange = _this$props.onGoodFilterChange;
    var searchTerm = goodFilters.get(_GoodFiltersAndPage.default.SEARCH_TERM);
    return _react.default.createElement("span", {
      className: "m-left-1"
    }, !!searchTerm && this.renderMatchingSearch(searchTerm), !(0, _utils.areAllSidebarFiltersAtInitialValue)(goodFilters) && this.renderSidebarFilterTags(goodFilters, onGoodFilterChange));
  }
});

exports.default = _default;
module.exports = exports.default;